import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import useMainBankAccountId from 'common/hooks/useMainBankAccountId';

import {
  ReviewerExpenseClaimRequestSidebarDetailDocument,
  ReviewerExpenseClaimRequestSidebarDetailQueryVariables,
} from './expenseClaimRequestDetail.gql';

type Input = Omit<
  ReviewerExpenseClaimRequestSidebarDetailQueryVariables,
  'companyProfileId' | 'bankAccountId'
>;

export const useExpenseClaimRequestDetail = (input: Input) => {
  const { companyProfileId } = useCompanyContext();
  const { mainBankAccountId } = useMainBankAccountId();

  const { data, ...hook } = useQuery(
    ReviewerExpenseClaimRequestSidebarDetailDocument,
    {
      notifyOnNetworkStatusChange: true,
      variables: {
        bankAccountId: mainBankAccountId ?? '',
        companyProfileId: companyProfileId ?? '',
        requestId: input.requestId,
      },
    },
  );

  const expenseClaimRequest = data?.expenseClaimRequest;
  const additionalSepaTransferFees =
    data?.viewer.company.currentPlan.fees.additionalSepaTransfer.fixed ?? 0;
  const hasExceededQuota =
    data?.viewer.company.subscriptionPlan?.quotas.sepaTransferMonthQuota
      .isExceeded ?? false;
  const nextBalance = data?.bankAccount.nextBalance ?? 0;

  return {
    additionalSepaTransferFees,
    expenseClaimRequest,
    hasExceededQuota,
    nextBalance,
    ...hook,
  } as const;
};
